import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Los estilos base/tokens deben cargar antes que los estilos de componentes para que
// las clases utilitarias compartidas (p. ej. .btn--ghost) no ganen por orden de
// importación sobre los estilos específicos de una sección (p. ej. .hero__delete).
import "./styles/base.css";
import { App } from "./App";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("No se encontró el elemento #root.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
